import React, {useCallback, useEffect, useRef, useState} from "react";
import Select, {createFilter} from "react-select";
import {useHistory, useLocation} from "react-router-dom";
import axios from "axios";
import {
    getBankingSettlementAccountInfoApi, getRegionsDetailsApi,
    getTerminalCassettesInfoApi,
    getTerminalContactDetailsByIDApi,
    getTerminalDetailByIDForEditApi,
    getTerminalNotesByIDApi,
    getTerminalSettlementByIDApi,
    getTerminalSurchargeByIDApi,
    saveTerminalEditFromPortalApi,
    TerminalDataTableListMgmtApi
} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import ConsoleHelper from "../ConsoleHelper";

const timeZoneOptions = [
    { value: "0",label: "Select Type Zone..",},
    { value: "1",label: "(GMT  -5:00) Eastern Time",},
{ value: "2",label: "(GMT  -4:00) Atlantic Time",},
{ value: "3",label: "(GMT  -6:00) Central Time",},
{ value: "4",label: "(GMT  -7:00) Mountain Time",},
{ value: "5",label: "(GMT  -8:00) Pacific Time",},
{ value: "6",label: "(GMT  -3:30) Newfoundland Time",},
{ value: "7",label: "(GMT  -9:00) Alaska Time",},
{ value: "8",label: "(GMT -10:00) Hawaii Time",},
{ value: "9",label: "(GMT  -6:00) Indiana Time",},
{ value: "10",label: "(GMT  -7:00) Arizona, Northeast BC",},
{ value: "11",label: "(GMT  -6:00) Saskatchewan Time",},
{ value: "12",label: "(GMT +5:30) India Time",},

];

const locationTypeOptions = [
    { value: "",label: "Select Location Type..",},
    { value: "TEST",label: "Test Terminals",},
    { value: "OTHR",label: "Other",},
    { value: "LIQR",label: "Beer/Liquor/Wine",},
    { value: "CONV",label: "Convenience Store",},
    { value: "DEPT",label: "Department Store",},
    { value: "DRUG",label: "Drug Store",},
    { value: "GASA",label: "Gas Stations/Auto",},
    { value: "HARD",label: "Hardware &amp; Gardening",},
    { value: "TRVL",label: "Airport/Train/Bus",},
    { value: "REST",label: "Restaurant",},
    { value: "PROF",label: "Professional Services",},
    { value: "SMFS",label: "Small Food Specialty",},
    { value: "SPEC",label: "Specialty Store",},
    { value: "SUPR",label: "Supermarket",},
    { value: "UTIL",label: "Utility &amp; Government",},
    { value: "BARP",label: "Bar/Pub",},
    { value: "GOLF",label: "Golf Club",},
    { value: "FINA",label: "Financial Institution",},
    { value: "MALL",label: "Shopping Mall",},
    { value: "HOTL",label: "Hotel",},
    { value: "CASI",label: "Casino",},
    { value: "HOSP",label: "Hospital",},
    { value: "COMN",label: "Community Ctr/Sports Venue",},
    { value: "CINE",label: "Cinema",},
    { value: "POOL",label: "Billiard Hall",},
    { value: "BOWL",label: "Bowling Alley",},
    { value: "BING",label: "Bingo Hall",},
    { value: "SKIR",label: "Ski Resort",},
    { value: "CMPS",label: "School/College Campus",},
];

const feeTypeOptions = [
    {
        value: "2",
        label: "Fixed Dollar",
    },
    {
        value: "3",
        label: "Percentage",
    },
];

const stateOptions = [
    { value: "0",label: "Select Region..",},
    { value: "14",label: "Alaska",},
    { value: "15",label: "Alabama",},
    { value: "16",label: "Arkansas",},
    { value: "17",label: "Arizona",},
    { value: "18",label: "California",},
    { value: "19",label: "Colorado",},
    { value: "20",label: "Connecticut",},
    { value: "21",label: "District of Columbia",},
    { value: "22",label: "Delaware",},
    { value: "23",label: "Florida",},
    { value: "24",label: "Georgia",},
    { value: "25",label: "Hawaii",},
    { value: "26",label: "Iowa",},
    { value: "27",label: "Idaho",},
    { value: "28",label: "Illinois",},
    { value: "29",label: "Indiana",},
    { value: "30",label: "Kansas",},
    { value: "31",label: "Kentucky",},
    { value: "32",label: "Louisiana",},
    { value: "33",label: "Massachusetts",},
    { value: "34",label: "Maryland",},
    { value: "35",label: "Maine",},
    { value: "36",label: "Michigan",},
    { value: "37",label: "Minnesota",},
    { value: "38",label: "Missouri",},
    { value: "39",label: "Mississippi",},
    { value: "40",label: "Montana",},
    { value: "41",label: "North Carolina",},
    { value: "42",label: "North Dakota",},
    { value: "43",label: "Nebraska",},
    { value: "44",label: "New Hampshire",},
    { value: "45",label: "New Jersey",},
    { value: "46",label: "New Mexico",},
    { value: "47",label: "Nevada",},
    { value: "48",label: "New York",},
    { value: "49",label: "Ohio",},
    { value: "50",label: "Oklahoma",},
    { value: "51",label: "Oregon",},
    { value: "52",label: "Pennsylvania",},
    { value: "53",label: "Rhode Island",},
    { value: "54",label: "South Carolina",},
    { value: "55",label: "South Dakota",},
    { value: "56",label: "Tennessee",},
    { value: "57",label: "Texas",},
    { value: "58",label: "Utah",},
    { value: "59",label: "Virginia",},
    { value: "60",label: "Vermont",},
    { value: "61",label: "Washington",},
    { value: "62",label: "Wisconsin",},
    { value: "63",label: "West Virginia",},
    { value: "64",label: "Wyoming",},
    { value: "1",label: "Undefined",},
];

const makeModelTypeOptions = [
    { value: "0",label: "Select Make &amp; Model..",},
    { value: "4",label: "BVC - Micro 2001",},
    { value: "16",label: "Glory - HC/iACT 2000",},
    { value: "17",label: "Greenlink - C-1000",},
    { value: "18",label: "Greenlink - Merlin",},
    { value: "19",label: "Greenlink - T-1000",},
    { value: "20",label: "Greenlink - U-1000",},
    { value: "21",label: "Money Tree - MT 2000",},
    { value: "42",label: "Triton - 9100 Colour",},
    { value: "43",label: "Triton - 9100 Mono",},
    { value: "44",label: "Triton - 9110",},
    { value: "45",label: "Triton - 9600",},
    { value: "46",label: "Triton - 9610",},
    { value: "47",label: "Triton - 9615",},
    { value: "48",label: "Triton - 9620",},
    { value: "49",label: "Triton - 9635",},
    { value: "50",label: "Triton - 9640",},
    { value: "51",label: "Triton - 9650",},
    { value: "52",label: "Triton - 9660",},
    { value: "53",label: "Triton - 9700",},
    { value: "54",label: "Triton - 9705",},
    { value: "55",label: "Triton - 9710",},
    { value: "56",label: "Triton - 9750",},
    { value: "57",label: "Triton - 9770",},
    { value: "58",label: "Triton - Mako",},
    { value: "1",label: "Boink - Boink",},
    { value: "24",label: "NCR - 5303 ATM Ease",},
    { value: "27",label: "NCR - 5305 ATM Ease",},
    { value: "33",label: "Qualtex - Weathermaster",},
    { value: "70",label: "Triton - RL5000",},
    { value: "92",label: "Lipman - Nurit 6100 Scrip",},
    { value: "93",label: "Lipman - Nurit 8100 Scrip",},
    { value: "94",label: "Triton - 9500",},
    { value: "95",label: "WRG - Genesis",},
    { value: "88",label: "Triton - 8000",},
    { value: "90",label: "Communiteq - ETM P Series",},
    { value: "100",label: "Lipman - Nurit 2085 Plus",},
    { value: "107",label: "Triton - RL-5000",},
    { value: "108",label: "Triton - RT2000",},
    { value: "109",label: "Triton - FT5000",},
    { value: "110",label: "MoneyTree - ID 2000 (Triton Emulation)",},
    { value: "135",label: "WRG - Apollo",},
    { value: "139",label: "Triton - RL2000",},
    { value: "140",label: "MoneyTree - ID 4000 (Triton Emulation)",},
    { value: "141",label: "MoneyTree - MT 4000 (Triton Emulation)",},
    { value: "142",label: "Nautilus/Hyosung - 1500 (Triton Standard 3)",},
    { value: "143",label: "Nautilus/Hyosung - 1520 (Triton Standard 3)",},
    { value: "156",label: "Lipman - Nurit 6000",},
    { value: "154",label: "Nautilus/Hyosung - 1540 (Triton Standard 3)",},
    { value: "152",label: "Nautilus/Hyosung - 5050 (Triton Standard 3)",},
    { value: "145",label: "Nautilus/Hyosung - 1800 (Triton Standard 3)",},
    { value: "105",label: "Tidel - 3300",},
    { value: "106",label: "Tidel - 3600",},
    { value: "32",label: "NG - Smarttouch ATM",},
    { value: "96",label: "Tidel - 3050",},
    { value: "36",label: "Tidel - 3100",},
    { value: "37",label: "Tidel - 3400",},
    { value: "38",label: "Tidel - IS-1000",},
    { value: "39",label: "Tidel - IS-2000",},
    { value: "40",label: "Tidel - IS-6000",},
    { value: "41",label: "Tranax - 1500 (Standard 1)",},
    { value: "97",label: "Diebold - CSP 100",},
    { value: "87",label: "Hantle - C4000 (Standard 1)",},
    { value: "91",label: "Tranax - 1500",},
    { value: "102",label: "Diebold - CSP 200P",},
    { value: "5",label: "Chungho - Comnet 1000",},
    { value: "6",label: "Chungho - Comnet 2000",},
    { value: "7",label: "Chungho - Comnet 4000",},
    { value: "8",label: "Tranax - NanoCash",},
    { value: "9",label: "Tranax - 1000 (Standard 1)",},
    { value: "10",label: "Tranax - 2000 (Standard 1)",},
    { value: "11",label: "Tranax - 2100 (Standard 1)",},
    { value: "12",label: "Tranax - 2200 (Standard 1)",},
    { value: "13",label: "Diebold - CSP 200",},
    { value: "144",label: "Nautilus/Hyosung - 1800 (Standard 1)",},
    { value: "153",label: "Nautilus/Hyosung - 1540 (Standard 1)",},
    { value: "136",label: "Hantle - 1700 (Standard 1)",},
    { value: "137",label: "Nautilus/Hyosung - 1500 (Standard 1)",},
    { value: "138",label: "Nautilus/Hyosung - 1520 (Standard 1)",},
    { value: "151",label: "Nautilus/Hyosung - 5050 (Standard 1)",},
    { value: "157",label: "Nextran - 1000",},
    { value: "158",label: "Nextran - 2000",},
    { value: "159",label: "Nextran - 3000",},
    { value: "160",label: "Nextran - 7100",},
    { value: "22",label: "Money Tree - MT 4000",},
    { value: "34",label: "TBS - 7900",},
    { value: "35",label: "TBS - 8000",},
    { value: "28",label: "NCR - 5670",},
    { value: "29",label: "NCR - 5870",},
    { value: "30",label: "NCR - 5870 Aptra",},
    { value: "31",label: "NCR - MCD1",},
    { value: "25",label: "NCR - 5305",},
    { value: "26",label: "NCR - 5305 Aptra",},
    { value: "98",label: "NCR - 5880",},
    { value: "23",label: "NCR - 3270 bisync",},
    { value: "14",label: "Diebold - CSP 400",},
    { value: "15",label: "Fujitsu - 7000 s",},
    { value: "99",label: "Diebold - 1064",},
    { value: "103",label: "Diebold - CSP 400P",},
    { value: "101",label: "Diebold - 1062",},
    { value: "3",label: "IBM - IBM0087",},
    { value: "62",label: "Diebold - Opteva/ix - no User Exit",},
    { value: "59",label: "Verifone - Omni 3300",},
    { value: "161",label: "Tranax - 1000 (Triton Standard 3)",},
    { value: "149",label: "Tranax - E4000 (Standard 1)",},
    { value: "162",label: "Tranax - 1500 (Triton Standard 3)",},
    { value: "163",label: "Tranax - 2100 (Triton Standard 3)",},
    { value: "164",label: "Tranax - 2200 (Triton Standard 3)",},
    { value: "165",label: "Hantle - 1700 (Triton Standard 3)",},
    { value: "166",label: "Hantle - C4000 (Triton Standard 3)",},
    { value: "169",label: "Triton - RL1600",},
    { value: "170",label: "Triton - 8100",},
    { value: "171",label: "Nautilus/Hyosung - 2700CE (Standard 1)",},
    { value: "172",label: "Nautilus/Hyosung - 2700CE (Triton Standard 3)",},
    { value: "173",label: "Hantle - 1700W (Standard 1)",},
    { value: "174",label: "Hantle - 1700W (Triton Standard 3)",},
    { value: "175",label: "Triton - Traverse RL3XXX",},
    { value: "176",label: "Triton - Argo 7",},
{ value: "177",label: "Triton - Argo 12",},
{ value: "178",label: "Nautilus/Hyosung - MX 5000SE (Standard 1)",},
{ value: "179",label: "Nautilus/Hyosung - MX 5000SE (Standard 3)",},
{ value: "180",label: "Nautilus/Hyosung - MX 5300CE (Standard 1)",},
{ value: "181",label: "Nautilus/Hyosung - MX 5300CE (Standard 3)",},
{ value: "182",label: "Nautilus/Hyosung - MX 5300XP (Standard 1)",},
{ value: "183",label: "Nautilus/Hyosung - MX 5300XP (Standard 3)",},
{ value: "184",label: "Nautilus/Hyosung - MX 4000W (Standard 1)",},
{ value: "185",label: "Nautilus/Hyosung - MX 4000W (Standard 3)",},
{ value: "186",label: "Nautilus/Hyosung - 2600 Halo (Standard 1)",},
{ value: "187",label: "Nautilus/Hyosung - 2600 Halo (Standard 3)",},
{ value: "188",label: "Genmega - G2500 (Triton Standard 3)",},
{ value: "189",label: "Wincor - 1500XE NDC",},
{ value: "190",label: "Wincor - SlimCash 200",},
{ value: "191",label: "Wincor - PC280 NDC",},
{ value: "192",label: "Triton - Argo FT",},
{ value: "194",label: "Genmega - 2500 (Standard 1)",},
{ value: "195",label: "Genmega - 1900 (Triton Standard 3)",},
{ value: "196",label: "Genmega - 1900 (Standard 1)",},
{ value: "197",label: "Genmega - 3000 (Triton Standard 3)",},
{ value: "198",label: "Genmega - 3000 (Standard 1)",},
{ value: "199",label: "Genmega - 5010 (Triton Standard 3)",},
{ value: "200",label: "Genmega - 5010 (Standard 1)",},
{ value: "201",label: "Genmega - 6000 (Triton Standard 3)",},
{ value: "202",label: "Genmega - 5000 (Standard 1)",},
{ value: "203",label: "Genmega - Onyx (Triton Standard 3)",},
{ value: "204",label: "Genmega - Onyx (Standard 1)",},
{ value: "205",label: "Nautilus/Hyosung - Force(Triton Standard 1)",},
{ value: "206",label: "Nautilus/Hyosung - Force(Triton Standard 3)",},
{ value: "207",label: "CountR Standard 1 - CountR(Triton Standard 1)",},
];


const cassetteTypeOptions = [
    {value: "1",label: "1",},
    {value: "2",label: "2",},
    {value: "3",label: "3",},
    {value: "4",label: "4",},
    {value: "5",label: "5",},
    {value: "6",label: "6",},
];
const cassetteValueOptions = [
    {value: "1",label: "1",},
    {value: "5",label: "5",},
    {value: "10",label: "10",},
    {value: "20",label: "20",},
    {value: "50",label: "50",},
    {value: "100",label: "100",},
];

/** Decode option labels for SEPRATOR strings (matches create-terminal option values). */
function labelForSep(label) {
    if (label == null) {
        return "";
    }
    return String(label).replace(/&amp;/g, "&");
}

function optionByValue(options, value) {
    return (options || []).find((o) => String(o.value) === String(value));
}

function settlementLabelForId(settlementOptions, id) {
    if (id === undefined || id === null || id === "") {
        return "";
    }
    return optionByValue(settlementOptions, id)?.label ?? "";
}

/**
 * Gathers every field from the edit form plus context for a future terminal-edit API.
 * Shapes mirror saveTerminalDetails (query string + JSON body) so you can plug the backend later.
 * TerminalEditPage only — do not import from TerminalCreatePage.
 */
function collectTerminalEditSaveParams(form, ctx) {
    if (!form) {
        return null;
    }
    const {
        termId,
        userID,
        notesDetails,
        settlementOptions,
        terminalDetailSnapshot,
    } = ctx;

    const fd = new FormData(form);
    const rawForm = {};
    fd.forEach((val, key) => {
        rawForm[key] = val;
    });
    const advEl = form.elements.namedItem("advCheck");
    rawForm.advCheck = advEl && advEl.type === "checkbox" ? advEl.checked : false;

    const paramStateText = rawForm.state ?? "";
    const settlementAccountId = rawForm.paramSettlementText != null ? String(rawForm.paramSettlementText) : "";
    const settlementLabel = settlementLabelForId(settlementOptions, settlementAccountId);

    const tzOpt = optionByValue(timeZoneOptions, rawForm.timeZone);
    const paramTimeZoneText = tzOpt ? `${tzOpt.value}SEPRATOR${tzOpt.label}` : String(rawForm.timeZone ?? "");

    const lcOpt = optionByValue(locationTypeOptions, rawForm.paramLCType);
    const paramLCTypeCombined = lcOpt
        ? `${lcOpt.value}SEPRATOR${labelForSep(lcOpt.label)}`
        : String(rawForm.paramLCType ?? "");

    const mmOpt = optionByValue(makeModelTypeOptions, rawForm.termBrandModel);
    const paramModelIDCombined = mmOpt
        ? `${mmOpt.value}SEPRATOR${labelForSep(mmOpt.label)}`
        : String(rawForm.termBrandModel ?? "");

    const ftOpt = optionByValue(feeTypeOptions, rawForm.feesType);
    const paramFeeTypeCombined = ftOpt
        ? `${ftOpt.value}SEPRATOR${ftOpt.label}`
        : String(rawForm.feesType ?? "");

    const paramCassettes = rawForm.cassettes ?? "";
    const surcharges = [1, 2, 3, 4].map((n) => {
        const accountId = rawForm[`surcharge${n}List`] != null ? String(rawForm[`surcharge${n}List`]) : "";
        return {
            index: n,
            accountId,
            accountLabel: settlementLabelForId(settlementOptions, accountId),
            surchargeTypeCode: rawForm[`surcharge${n}Type`] != null ? String(rawForm[`surcharge${n}Type`]) : "1",
            splitAmountText: rawForm[`percentageSur${n}Txt`] != null ? String(rawForm[`percentageSur${n}Txt`]) : "",
        };
    });

    /** Same names as TerminalController.saveTerminalDetailsInfoMap expects inside `data` JSON. */
    const saveTerminalDetailsDataJson = {
        paramLocationName: rawForm.businessLocName ?? "",
        paramTypeOfChangeText: "",
        paramBusinessDBAText: "",
        paramModelID: paramModelIDCombined,
        paramAddress: rawForm.address ?? "",
        paramSerialNo: rawForm.termSerial ?? "",
        paramCity: rawForm.city ?? "",
        paramFeeType: paramFeeTypeCombined,
        paramPostalCode: rawForm.zip ?? "",
        paramFeeAmount: rawForm.amount ?? "",
        paramBlockEBT: Boolean(rawForm.advCheck),
        paramTimeZoneText: paramTimeZoneText,
        paramLocationContactText: "",
        paramLCType: paramLCTypeCombined,
        paramLocationPhoneText: "",
        paramBusinessTaxIdText: "",
        paramYearsInBusinessText: "",
        paramYearsAtCurrentLocationText: "",
        paramCassette1: rawForm.paramCassette1 ?? "",
        paramCassette2: rawForm.paramCassette2 ?? "",
        paramCassette3: rawForm.paramCassette3 ?? "",
        paramCassette4: rawForm.paramCassette4 ?? "",
        paramCassette5: rawForm.paramCassette5 ?? "",
        paramCassette6: rawForm.paramCassette6 ?? "",
        paramSurchargeType1Text: surcharges[0].surchargeTypeCode,
        paramSurchargePercentage1Text: surcharges[0].splitAmountText,
        paramSurchargeType2Text: surcharges[1].surchargeTypeCode,
        paramSurchargePercentage2Text: surcharges[1].splitAmountText,
        paramSurchargeType3Text: surcharges[2].surchargeTypeCode,
        paramSurchargePercentage3Text: surcharges[2].splitAmountText,
        paramSurchargeType4Text: surcharges[3].surchargeTypeCode,
        paramSurchargePercentage4Text: surcharges[3].splitAmountText,
        paramContactName1: rawForm.nameRow1 ?? "",
        paramPhone1: rawForm.PhoneRow1 ?? "",
        paramEMail1: rawForm.emailRow1 ?? "",
        paramContactName2: rawForm.nameRow2 ?? "",
        paramPhone2: rawForm.PhoneRow2 ?? "",
        paramEMail2: rawForm.emailRow2 ?? "",
        paramContactName3: rawForm.nameRow3 ?? "",
        paramPhone3: rawForm.PhoneRow3 ?? "",
        paramEMail3: rawForm.emailRow3 ?? "",
        termOwner: "",
        ssn: "",
        driverLicense: "",
        stateIssued: "",
        ownerAddress: "",
        ownerCity: "",
        ownerState: "",
        ownerZip: "",
        ownerPhone: "",
        ownerDOB: "",
        ownerPercentage: "",
        paramNoteText: rawForm.notesText ?? "",
    };

    /** Same query parameters as TerminalCreatePage passes to saveTerminalDetails (GET). */
    const saveTerminalDetailsQuery = {
        paramStateText,
        paramCassettes: paramCassettes,
        settlementValue: settlementAccountId,
        settlementValue1: surcharges[0].accountId || "-1",
        settlementValue2: surcharges[1].accountId || "-1",
        settlementValue3: surcharges[2].accountId || "-1",
        settlementValue4: surcharges[3].accountId || "-1",
        userID: userID ?? "",
        paramSettlementText: settlementLabel,
        paramSurcharge1Text: surcharges[0].accountLabel,
        paramSurcharge2Text: surcharges[1].accountLabel,
        paramSurcharge3Text: surcharges[2].accountLabel,
        paramSurcharge4Text: surcharges[3].accountLabel,
    };

    return {
        termId,
        userID,
        noteMeta: {
            noteID: notesDetails?.noteID ?? null,
            sourceType: notesDetails?.sourceType ?? null,
            sourceCode: notesDetails?.sourceCode ?? termId,
            noteType: notesDetails?.noteType ?? null,
        },
        /** Original GET response for this terminal (read-only snapshot when save was clicked). */
        terminalDetailSnapshot: terminalDetailSnapshot ?? null,
        rawForm,
        surcharges,
        saveTerminalDetailsDataJson,
        saveTerminalDetailsQuery,
        /** Ready for POST/PUT body tomorrow: one object with everything explicit. */
        proposedApiBody: {
            termId,
            userID,
            noteMeta: {
                noteID: notesDetails?.noteID ?? null,
                sourceType: notesDetails?.sourceType ?? null,
                sourceCode: notesDetails?.sourceCode ?? termId,
                noteType: notesDetails?.noteType ?? null,
            },
            terminalDetailSnapshot: terminalDetailSnapshot ?? null,
            form: rawForm,
            saveTerminalDetailsDataJson,
            saveTerminalDetailsQuery,
        },
    };
}

function parseIntSafe(v, def = 0) {
    const n = parseInt(String(v ?? "").trim(), 10);
    return Number.isNaN(n) ? def : n;
}

/** Tolerance for comparing percentage totals (100%) and dollar amounts. */
const SURCHARGE_DISTRIBUTION_EPS = 0.02;

function parseFeeAmount(raw) {
    const n = parseFloat(String(raw ?? "").replace(/,/g, "").trim());
    return Number.isNaN(n) ? NaN : n;
}

/** Surcharge type "0" = %, "1" = Fixed (matches select values). Stored proc expects a fraction for % (e.g. 0.2 for 20%). */
function surchargeValueForPayload(typeStr, displayValue) {
    const n = parseFloat(String(displayValue ?? "").replace(/,/g, "").trim());
    if (Number.isNaN(n)) {
        return 0;
    }
    if (typeStr === "0") {
        return n / 100;
    }
    return n;
}

/** Show whole-number % in the form when API returns a fraction (0.2 → 20); leave legacy whole values (60) as-is. */
function surchargeSplitAmountDisplay(splitType, splitAmount) {
    if (splitAmount == null || splitAmount === "") {
        return "";
    }
    const n = typeof splitAmount === "number" ? splitAmount : parseFloat(String(splitAmount).replace(/,/g, "").trim());
    if (Number.isNaN(n)) {
        return String(splitAmount);
    }
    if (splitType === 0 && Math.abs(n) <= 1) {
        const pct = Math.round(n * 10000) / 100;
        return String(Number.isInteger(pct) ? pct : parseFloat(pct.toFixed(4)));
    }
    return String(splitAmount);
}

function collectActiveSurchargeRows(rawForm) {
    const rows = [];
    for (let n = 1; n <= 4; n++) {
        const id = parseIntSafe(rawForm[`surcharge${n}List`], 0);
        if (!id) {
            continue;
        }
        const typeStr = String(parseIntSafe(rawForm[`surcharge${n}Type`], 1));
        const val = parseFeeAmount(rawForm[`percentageSur${n}Txt`]);
        rows.push({ n, id, type: typeStr, val: Number.isNaN(val) ? 0 : val });
    }
    return rows;
}

/**
 * Validates Fees vs surcharge split: %-rows total 100%; all-Fixed rows must match Fees (amount or % number).
 * @returns {string|null} Error message, or null if valid / no surcharge rows.
 */
function validateSurchargeFeeDistribution(rawForm) {
    const feeType = String(parseIntSafe(rawForm.feesType, 0));
    const feeAmount = parseFeeAmount(rawForm.amount);
    const rows = collectActiveSurchargeRows(rawForm);
    if (rows.length === 0) {
        return null;
    }

    const pctRows = rows.filter((r) => r.type === "0");
    const fixedRows = rows.filter((r) => r.type === "1");
    const fixSum = fixedRows.reduce((s, r) => s + r.val, 0);
    const pctSum = pctRows.reduce((s, r) => s + r.val, 0);
    const hasPct = pctRows.length > 0;

    if (hasPct && Math.abs(pctSum - 100) > SURCHARGE_DISTRIBUTION_EPS) {
        return `Surcharge rows set to % must add up to 100% (current total: ${pctSum.toFixed(2)}%).`;
    }

    if (feeType === "2") {
        if (Number.isNaN(feeAmount) || feeAmount < 0) {
            return "Enter a valid Fees amount for Fixed Dollar.";
        }
        if (hasPct) {
            if (fixSum > feeAmount + SURCHARGE_DISTRIBUTION_EPS) {
                return (
                    `The sum of fixed surcharge amounts (${fixSum.toFixed(2)}) cannot exceed ` +
                    `the Fees amount (${feeAmount.toFixed(2)}).`
                );
            }
        } else if (fixedRows.length > 0) {
            if (Math.abs(fixSum - feeAmount) > SURCHARGE_DISTRIBUTION_EPS) {
                return (
                    `Fixed surcharge amounts must equal the Fees amount (${feeAmount.toFixed(2)}); ` +
                    `current sum is ${fixSum.toFixed(2)}.`
                );
            }
        }
        return null;
    }

    if (feeType === "3") {
        if (Number.isNaN(feeAmount) || feeAmount < 0) {
            return "Enter a valid Fees percentage.";
        }
        /** When Fees are Percentage and every surcharge row is Fixed, their values must add up to that percentage (e.g. 10 vs 6+3). */
        if (!hasPct && fixedRows.length > 0) {
            if (Math.abs(fixSum - feeAmount) > SURCHARGE_DISTRIBUTION_EPS) {
                return (
                    `Fixed surcharge amounts must add up to the Fees percentage (${feeAmount.toFixed(2)}); ` +
                    `current sum is ${fixSum.toFixed(2)}.`
                );
            }
        }
        return null;
    }

    return null;
}

/** Normalizes Spring `Map` JSON: `{ response: { updateTermInfo, …, allSuccess } }` or a flat body. */
function extractSavePortalSteps(res) {
    const d = res?.data;
    if (!d || typeof d !== "object") {
        return {};
    }
    const inner = d.response;
    if (inner && typeof inner === "object" && !Array.isArray(inner)) {
        return inner;
    }
    if (d.allSuccess !== undefined || d.updateTermInfo !== undefined) {
        return d;
    }
    return {};
}

function isTerminalEditSaveAllSuccess(steps) {
    const v = steps?.allSuccess;
    return v === true || v === "true";
}

const REGION_OPTION_SEP = "SEPRATOR";

/** Region select value may be "14SEPRATORAlabama" from API options. */
function regionIdFromStateSelect(stateVal) {
    const s = String(stateVal ?? "");
    const i = s.indexOf(REGION_OPTION_SEP);
    if (i >= 0) {
        return parseIntSafe(s.substring(0, i), 0);
    }
    return parseIntSafe(s, 0);
}

/** Picks the option whose id prefix matches `locationRegionId` exactly (avoids `startsWith("1")` matching 14, 16, …). */
function regionOptionValueForRegionId(regionOptions, locationRegionId) {
    if (!regionOptions || regionOptions.length === 0) {
        return "";
    }
    if (locationRegionId == null || locationRegionId === "") {
        return "";
    }
    const idStr = String(locationRegionId);
    const found = regionOptions.find((option) => {
        const v = String(option.value ?? "");
        const i = v.indexOf(REGION_OPTION_SEP);
        const prefix = i >= 0 ? v.slice(0, i) : v;
        return prefix === idStr;
    });
    return found?.value ?? "";
}

function dollarAmountToCentsInt(amountStr) {
    const n = parseFloat(String(amountStr ?? "").replace(/,/g, "").trim());
    if (Number.isNaN(n)) {
        return 0;
    }
    return Math.round(n * 100);
}

function cassetteDenominationCents(rawForm, slotIndex) {
    const denom = parseIntSafe(rawForm[`paramCassette${slotIndex}`], 0);
    return denom * 100;
}

/**
 * Builds the nested JSON for {@code GET saveTerminalEditFromPortal?data=...} (keys match Java {@code DataStreamTerminalEditEnum} / {@code DataStreamEnum}).
 */
function buildSaveTerminalEditPortalPayload(rawForm, termId, contactData, detailRow) {
    const detail = detailRow && !Array.isArray(detailRow) ? detailRow : null;
    const functionFlags = detail?.functionFlags != null ? String(detail.functionFlags) : "0";

    const termInfo = {
        paramTerminalID: termId,
        paramlocationName: rawForm.businessLocName ?? "",
        paramaddress: rawForm.address ?? "",
        paramcity: rawForm.city ?? "",
        paramstate: String(regionIdFromStateSelect(rawForm.state)),
        paramzipCode: rawForm.zip ?? "",
        paramtimeZone: String(parseIntSafe(rawForm.timeZone, 0)),
        paramlocationType: rawForm.paramLCType ?? "",
        parammodel: String(parseIntSafe(rawForm.termBrandModel, 0)),
        paramserialNum: rawForm.termSerial ?? "",
        paramfeeType: String(parseIntSafe(rawForm.feesType, 0)),
        paramfeeValue: String(dollarAmountToCentsInt(rawForm.amount)),
        paramfunctionFlags: functionFlags,
    };

    const cassettes = {
        paramTerminalID: termId,
        paramMediaValue1: String(cassetteDenominationCents(rawForm, 1)),
        paramMediaValue2: String(cassetteDenominationCents(rawForm, 2)),
        paramMediaValue3: String(cassetteDenominationCents(rawForm, 3)),
        paramMediaValue4: String(cassetteDenominationCents(rawForm, 4)),
        paramMediaValue5: String(cassetteDenominationCents(rawForm, 5)),
        paramMediaValue6: String(cassetteDenominationCents(rawForm, 6)),
    };

    const settlementAccountId = parseIntSafe(rawForm.paramSettlementText, 0);
    const settlement = {
        paramTerminalID: termId,
        paramAccountID: String(settlementAccountId),
    };

    const sur = (n) => {
        const idRaw = rawForm[`surcharge${n}List`];
        const id = String(idRaw ?? "").trim() === "" ? "0" : String(parseIntSafe(idRaw, 0));
        const type = String(parseIntSafe(rawForm[`surcharge${n}Type`], 1));
        const pctRaw = rawForm[`percentageSur${n}Txt`];
        const pct = surchargeValueForPayload(type, pctRaw);
        return { id, type, pct };
    };
    const s1 = sur(1);
    const s2 = sur(2);
    const s3 = sur(3);
    const s4 = sur(4);
    const surcharge = {
        paramTerminalID: termId,
        paramSurchargeAccountID1: s1.id,
        paramSurchargeAccountID2: s2.id,
        paramSurchargeAccountID3: s3.id,
        paramSurchargeAccountID4: s4.id,
        paramSurchargeType1: s1.type,
        paramSurchargeType2: s2.type,
        paramSurchargeType3: s3.type,
        paramSurchargeType4: s4.type,
        paramSurchargePercentage1: String(s1.pct === 0 ? 0 : Number(s1.pct.toFixed(8))),
        paramSurchargePercentage2: String(s2.pct === 0 ? 0 : Number(s2.pct.toFixed(8))),
        paramSurchargePercentage3: String(s3.pct === 0 ? 0 : Number(s3.pct.toFixed(8))),
        paramSurchargePercentage4: String(s4.pct === 0 ? 0 : Number(s4.pct.toFixed(8))),
    };

    const c = (i) => (contactData && contactData[i] ? contactData[i] : {});
    const contacts = {
        paramSourceCode: termId,
        paramContactID1: String(c(0).contactID ?? ""),
        paramContactID2: String(c(1).contactID ?? ""),
        paramContactID3: String(c(2).contactID ?? ""),
        paramContactName1: rawForm.nameRow1 ?? "",
        paramContactName2: rawForm.nameRow2 ?? "",
        paramContactName3: rawForm.nameRow3 ?? "",
        paramPhone1: rawForm.PhoneRow1 ?? "",
        paramPhone2: rawForm.PhoneRow2 ?? "",
        paramPhone3: rawForm.PhoneRow3 ?? "",
        paramFax1: String(c(0).fax ?? ""),
        paramFax2: String(c(1).fax ?? ""),
        paramFax3: String(c(2).fax ?? ""),
        paramEMail1: rawForm.emailRow1 ?? "",
        paramEMail2: rawForm.emailRow2 ?? "",
        paramEMail3: rawForm.emailRow3 ?? "",
    };

    return {
        termInfo,
        cassettes,
        settlement,
        surcharge,
        contacts,
    };
}


const formErrors = {};

function TerminalEditPage(props) {

    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const location = useLocation();
    const [data, setData] = useState();
    const [selectedCassetteValue, setSelectedCassetteValue] = useState();
    /** Number of cassette denomination rows (1–6); driven by "How many cassettes?" and reset when API cassettes load. */
    const [cassetteCount, setCassetteCount] = useState(1);
    const [terminalOptions, setTerminalOptions] = useState([]);
    const [settlementOptions, setSettlementOptions] = useState([]);
    const [settlementValue, setSettlementValue] = useState();
    const [contactData, setContactData] = useState();
    const [selectedSettlementAccountValue, setSelectedSettlementAccountValue] = useState();
    const [selectedSurchargeAccountValue, setSelectedSurchargeAccountValue] = useState();
    const [notesDetails, setNotesDetails] = useState();
    const [selectedTerminal, setSelectedTerminal] = useState();
    const [pending, setPending] = React.useState(true);
    const history = useHistory();
    const [regionOptions, setRegionOptions] = useState([]);
    const [selectedRegionValue, setRegionValue] = useState();
    const [saveMessage, setSaveMessage] = useState(null);
    const [saveInProgress, setSaveInProgress] = useState(false);
    /** True while terminal detail / surcharge / contacts are loading for the selected terminal (prevents saving stale form data). */
    const [terminalDetailLoading, setTerminalDetailLoading] = useState(true);
    const [editFormRemountKey, setEditFormRemountKey] = useState(0);
    const editFormRef = useRef(null);

    const fetchTerminalEditData = useCallback(async (termId) => {
        if (!termId) {
            return;
        }
        setTerminalDetailLoading(true);
        try {
            const detailsByIDResponse = await axios.get(`${getTerminalDetailByIDForEditApi}?termId=${termId}`);
            const cassettesByIDResponse = await axios.get(`${getTerminalCassettesInfoApi}?paramTermID=${termId}`);
            const settlementAccountByIDResponse = await axios.get(`${getTerminalSettlementByIDApi}?termId=${termId}`);
            const surchargeAccountByIDResponse = await axios.get(`${getTerminalSurchargeByIDApi}?termId=${termId}`);
            const contactResultSet = await axios.get(
                `${getTerminalContactDetailsByIDApi}?paramSourceCode=${termId}&paramSourceType=2`
            );
            const notesDetailsByIDResponse = await axios.get(`${getTerminalNotesByIDApi}?paramSourceCode=${termId}`);

            setData(detailsByIDResponse?.data?.response?.[0]);
            setSelectedCassetteValue(cassettesByIDResponse?.data?.response);
            setSelectedSettlementAccountValue(settlementAccountByIDResponse?.data?.response?.[0]);
            setSelectedSurchargeAccountValue(surchargeAccountByIDResponse?.data?.response);
            setContactData(contactResultSet?.data?.response);
            setNotesDetails(notesDetailsByIDResponse?.data?.response?.[0]);
        } finally {
            setTerminalDetailLoading(false);
        }
    }, []);

    useEffect(() => {
        const fetchRegions = async () => {
            try {
                const resultRegions = await axios.get(`${getRegionsDetailsApi}`);
                setRegionOptions(resultRegions?.data || []); // Handle potential undefined
            } catch (error) {
                console.error("Error fetching regions:", error);
                setRegionOptions([]); // Set to empty array on error
            }
        };
        fetchRegions();
    }, []);

    useEffect(() => {
        if (!selectedTerminal?.value) {
            return;
        }
        setSaveMessage(null);
        fetchTerminalEditData(selectedTerminal.value);
    }, [selectedTerminal, fetchTerminalEditData]);

    useEffect(() => {
        if (!Array.isArray(selectedCassetteValue)) {
            setCassetteCount(1);
            return;
        }
        const len = selectedCassetteValue.length;
        setCassetteCount(len > 0 ? len : 1);
    }, [selectedCassetteValue]);

    useEffect(() => {
        if (saveMessage?.variant !== "success") {
            return undefined;
        }
        const t = setTimeout(() => setSaveMessage(null), 6000);
        return () => clearTimeout(t);
    }, [saveMessage]);


    useEffect(() => {

        const fetchResults = async () => {
            /*let result = await axios.get(`${TerminalMgmtApi}?id=${loggedUserStorage}&searchCriteria=""&lastTxn=10&pageSize=50&currentPage=1&sortColumn=TerminalID&sortOrder=DESC`, {
                mode: 'no-cors' // 'cors' by default
            });*/
            let result = await axios.get(`${TerminalDataTableListMgmtApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
                mode: 'no-cors' // 'cors' by default
            });
            let accountResult = await axios.get(`${getBankingSettlementAccountInfoApi}?paramSourceType=1&paramSourceCode=Administrator&paramDestType=4&paramDestCode=-1&paramAssignCode=1&paramCurrentUserID=${loggedUserStorage}`);
            setSettlementOptions(accountResult?.data);
            console.log("======= ",result)
            setTerminalOptions(result?.data?.response);
            setSelectedTerminal({
                label: result?.data.response?.[0]?.terminalID,
                value: result?.data.response?.[0]?.terminalID,
            });
            setPending(false);
        };
        fetchResults();
        return () => {
            setTerminalOptions([]);
        };
    }, []);


    const handleRegionChange  = (e) => {
        setRegionValue((e));

        ConsoleHelper(" ---- Region Value",selectedRegionValue)
    };




    const handleEditFormSubmit = async (e) => {
        e.preventDefault();
        setSaveMessage(null);
        if (!selectedTerminal?.value) {
            setSaveMessage({
                variant: "danger",
                text: "Select a terminal before saving.",
            });
            return;
        }
        if (terminalDetailLoading) {
            setSaveMessage({
                variant: "warning",
                text: "Terminal details are still loading. Wait before saving.",
            });
            return;
        }
        const saveParams = collectTerminalEditSaveParams(editFormRef.current, {
            termId: selectedTerminal.value,
            userID: loggedUserStorage,
            notesDetails,
            settlementOptions,
            terminalDetailSnapshot: data,
        });
        if (!saveParams?.rawForm) {
            setSaveMessage({ variant: "danger", text: "Could not read form data." });
            return;
        }
        const distributionError = validateSurchargeFeeDistribution(saveParams.rawForm);
        if (distributionError) {
            setSaveMessage({ variant: "danger", text: distributionError });
            return;
        }
        const payload = buildSaveTerminalEditPortalPayload(
            saveParams.rawForm,
            selectedTerminal.value,
            contactData,
            data
        );
        setSaveInProgress(true);
        try {
            const res = await axios.get(
                `${saveTerminalEditFromPortalApi}?data=${encodeURIComponent(JSON.stringify(payload))}`
            );
            const steps = extractSavePortalSteps(res);
            console.log("[TerminalEditPage] saveTerminalEditFromPortal →", steps);
            if (isTerminalEditSaveAllSuccess(steps)) {
                setSaveMessage({
                    variant: "success",
                    text: "Terminal changes saved.",
                });
                try {
                    await fetchTerminalEditData(selectedTerminal.value);
                    // Defer remount to the next task so `setData` from refresh is committed before the form resets (fixes Region/state sticking to typed value).
                    setTimeout(() => {
                        setEditFormRemountKey((k) => k + 1);
                    }, 0);
                } catch (refreshErr) {
                    console.error("[TerminalEditPage] refresh after save failed", refreshErr);
                    setSaveMessage({
                        variant: "warning",
                        text:
                            "Save reported success, but reloading terminal data failed. Refresh the page to confirm values.",
                    });
                }
            } else {
                const failed = Object.entries(steps)
                    .filter(([k, v]) => k !== "allSuccess" && (v === false || v === "false"))
                    .map(([k]) => k)
                    .join(", ");
                setSaveMessage({
                    variant: "warning",
                    text: failed
                        ? `Save completed with issues: ${failed}. Check server logs.`
                        : "Save response was unexpected or incomplete. Check the console.",
                });
            }
        } catch (err) {
            console.error("[TerminalEditPage] saveTerminalEditFromPortal error", err);
            setSaveMessage({
                variant: "danger",
                text: err?.response?.data?.message || err?.message || "Save failed. See console for details.",
            });
        } finally {
            setSaveInProgress(false);
        }
    };

    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };

    if(pending){
        return <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    }

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card">
                    <form>
                        <div className="form-group form-inline" style={{margin:"auto",width:"25%",paddingTop:"15px"}}>
                            <label htmlFor="exampleInputEmail1">Terminal ID:</label>
                            <div className="input-group ml-2">
                                <Select
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    options={terminalOptions}
                                    onChange={(e) => setSelectedTerminal(e)}
                                    value={selectedTerminal}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            flex: 1,
                                        }),
                                    }}
                                />

                            </div>
                        </div>
                    </form>
                    <div className="card-body">
                      <form
                          ref={editFormRef}
                          key={`edit-terminal-${selectedTerminal?.value ?? ""}-${editFormRemountKey}`}
                          onSubmit={handleEditFormSubmit}
                      >
                        <div className="row">
                            <div className="col-md-6">
                                <h5 className="tbsub-title mt-3 mb-3">Terminal Setup Info</h5>
                                <div className="col-md-12">
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Location Name:</label>
                                        <input type="text" name="businessLocName"
                                               defaultValue={ data?.locationName}
                                               key={data?.locationName}
                                               className="form-control form-control-sm col-md-9" placeholder=" Location Name:"/>
                                    </div>

                                        <div className="form-group row">
                                                <label className="control-label col-md-3">Address:</label>
                                                <input type="text" name="address"
                                                       style={{ ...styles.input, borderColor: formErrors.address && "red" }}
                                                       defaultValue={ data?.locationAddress}
                                                       key={data?.locationAddress}
                                                       className="form-control form-control-sm col-md-9"  placeholder="Address"/>
                                            <div className="invalid-feedback">
                                                Please choose a Address.
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                                <label className="control-label col-md-3">City:</label>
                                                <input type="text" name="city"
                                                       style={{ ...styles.input, borderColor: formErrors.city && "red" }}
                                                       defaultValue={ data?.locationCity}
                                                       key={data?.locationCity}
                                                       className="form-control form-control-sm col-md-9" placeholder="City"/>
                                        </div>
                                        <div className="form-group row">
                                                <label className="control-label col-md-3">Zip Code:</label>
                                                <input type="text" name="zip"
                                                       style={{ ...styles.input, borderColor: formErrors.zip && "red" }}
                                                       defaultValue={ data?.locationZip}
                                                       key={data?.locationZip}
                                                       className="form-control form-control-sm col-md-9" placeholder="Zip Code"/>
                                        </div>

                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Region:</label>
                                        {<select
                                            name="state"
                                            className="form-control form-control-sm col-md-9 select2"
                                            defaultValue={regionOptionValueForRegionId(regionOptions, data?.locationRegion)}
                                            key={`state-${editFormRemountKey}-${data?.locationRegion}-${regionOptionValueForRegionId(regionOptions, data?.locationRegion)}-${regionOptions?.length ?? 0}`}
                                        >
                                            {regionOptions.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                        }
                                        {/*<Select
                                            options={regionOptions}
                                            value={selectedRegionValue}
                                            defaultValue={data?.locationRegion}
                                            onChange={handleRegionChange}
                                        />*/}

                                    </div>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> Time Zone:</label>
                                        {/*<select {...register("timeZone", { required: true, maxLength: 200 })}
                                                    style={{ ...styles.input, borderColor: errors.timeZone && "red" }}
                                                    className="form-control form-control-sm col-md-9 select2">
                                            </select>*/}
                                        <select name="timeZone" className="form-control form-control-sm col-md-9 select2"
                                                    defaultValue={ data?.timeZoneID}
                                                    key={data?.timeZoneID}>
                                                {timeZoneOptions.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group row">
                                            <label className="control-label col-md-3"> Location Type:</label>
                                            <select name="paramLCType" className="form-control form-control-sm col-md-9 select2"
                                                    defaultValue={ data?.locationType}
                                                    key={data?.locationType}>
                                                {locationTypeOptions.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <h5 className="tbsub-title mt-3 mb-3">&nbsp;</h5>
                                <div className="col-md-12">
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Make/Model:</label>
                                        <select name="termBrandModel" className="form-control form-control-sm col-md-9 select2"
                                                defaultValue={ data?.modelID}
                                                key={data?.modelID}>
                                            {makeModelTypeOptions.map((option) => (
                                                <option value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Serial No#:</label>
                                        <input type="text" name="termSerial"
                                               style={{ ...styles.input, borderColor: formErrors.termSerial && "red" }} defaultValue={ data?.serialNum}
                                               key={data?.serialNum}
                                               className="form-control form-control-sm col-md-9" placeholder="Terminal Serial #"/>
                                    </div>
                                    <h5 className="tbsub-title mt-3 mb-3">Fees:</h5>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Type:</label>
                                        <select name="feesType" className="form-control form-control-sm col-md-9 select2"
                                                defaultValue={ data?.feeType}
                                                key={data?.feeType}>
                                            {feeTypeOptions.map((option) => (
                                                <option value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Amount: :</label>
                                        <input type="text" name="amount"
                                               style={{ ...styles.input, borderColor: formErrors.amount && "red" }} defaultValue={data?.defaultFee/100}
                                               key={data?.defaultFee/100}
                                               className="form-control form-control-sm col-md-9" placeholder="Amount"/>
                                    </div>
                                    <div className="form-group row">
                                        <h5 className="tbsub-title mt-3 mb-3 col-md-6">Adv. Functions:</h5>
                                        <div className="col-md-6" style={{paddingTop:"15px"}}>
                                            <input name={"advCheck"}
                                                   style={{ ...styles.input, borderColor: formErrors.advCheck && "red" }}
                                                   className="form-check-input" type="checkbox" value=""
                                                   id="flexCheckDefault"/>
                                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                                    DCC
                                                </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <hr/>
                        {/* START OF CASSESTES*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign:"center"}}>Cassettes   (Minimum 1 cassette)</h5>
                                <div className="col-md-12">

                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> How many cassettes?:</label>
                                        <select
                                            name="cassettes"
                                            className="form-control form-control-sm col-md-9 select2"
                                            value={String(cassetteCount)}
                                            onChange={(e) => {
                                                const n = parseInt(e.target.value, 10);
                                                setCassetteCount(Number.isFinite(n) ? Math.min(6, Math.max(1, n)) : 1);
                                            }}
                                        >
                                            {cassetteTypeOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {Array.from({ length: cassetteCount }, (_, i) => {
                                        const denomDollars =
                                            selectedCassetteValue?.[i]?.mediaValue != null
                                                ? String(selectedCassetteValue[i].mediaValue / 100)
                                                : "1";
                                        return (
                                            <div key={`cassette-denom-${cassetteCount}-${i}-${denomDollars}`} className="form-group row">
                                                <label className="control-label col-md-3"> Cassette{i + 1}: (Denomination $)</label>
                                                <select
                                                    name={"paramCassette" + (i + 1)}
                                                    className="form-control form-control-sm col-md-9 select2"
                                                    defaultValue={denomDollars}
                                                >
                                                    {cassetteValueOptions.map((option) => (
                                                        <option key={option.value} value={option.value}>{option.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                        </div>
                        {/* START OF TERMINAL ACH DISTRO*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign:"center"}}>Terminal ACH Distribution   - Cash replenishment Account</h5>
                                <div className="col-md-12" style={{textAlign:"end"}}>
                                    <a href="javascript: void(0);">DOWNLOAD EXHIBIT C</a>
                                </div>
                                <h5 className="tbsub-title mt-3 mb-3">Account (Bank Name - Routing Number - Account Number)</h5>
                                <div className="col-md-12">
                                            <select name="paramSettlementText" className="form-control form-control-sm col-md-12 select2"
                                                    defaultValue={ selectedSettlementAccountValue?.accountID}
                                                    key={selectedSettlementAccountValue?.accountID}>
                                                {settlementOptions.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                </div>
                            </div>
                        </div>
                        {/* START OF SURCHARGE ACCOUNTS*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign:"center"}}>Surcharge Accounts</h5>
                                <div className="col-md-12" style={{textAlign:"end"}}>
                                    <a href="javascript: void(0);">DOWNLOAD EXHIBIT C</a>
                                </div>
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th scope="col"><h5>Account (Bank Name - Routing Number - Account Number)</h5></th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Value</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                            {
                                                selectedSurchargeAccountValue?.map(function(object, i){

                                                    return <tr><td>
                                                        <select name={"surcharge"+(i+1)+"List"} className="form-control form-control-sm col-md-9 select2"
                                                                defaultValue={ selectedSurchargeAccountValue[i]?.destCode}
                                                                key={selectedSurchargeAccountValue[i]?.destCode}>
                                                            {settlementOptions.map((option) => (
                                                                <option value={option.value}>{option.label}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                        <td>
                                                            <select
                                                                name={"surcharge"+(i+1)+"Type"}
                                                                className="form-control form-control-sm col-md-9 select2"
                                                                defaultValue={ selectedSurchargeAccountValue[i]?.splitType === 0 ? "0" : "1" }
                                                                key={`sur-type-${i}-${selectedSurchargeAccountValue[i]?.splitType}`}
                                                            >
                                                                <option value="1">Fixed</option>
                                                                <option value="0">%</option>
                                                            </select>
                                                        </td>
                                                            <td>
                                                                <input
                                                                    className="form-control form-control-sm col-md-6"
                                                                    name={"percentageSur"+(i+1)+"Txt"}
                                                                    defaultValue={surchargeSplitAmountDisplay(
                                                                        selectedSurchargeAccountValue[i]?.splitType,
                                                                        selectedSurchargeAccountValue[i]?.splitAmount
                                                                    )}
                                                                    key={`${selectedSurchargeAccountValue[i]?.splitType}-${selectedSurchargeAccountValue[i]?.splitAmount}`}
                                                                    type="text"
                                                                    placeholder="($)Value"
                                                                />
                                                            </td>
                                                    </tr>

                                                })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <span className="tbsub-title mt-3 mb-12" style={{textAlign:"center",color:"red",fontSize:"12px"}}>Surcharge rows using % must total 100%. If every surcharge row is Fixed only, their values must add up to the Fees amount (Fixed Dollar) or to the Fees percentage number (Percentage). With Fixed Dollar and a mix of Fixed and %, fixed amounts cannot exceed the Fees amount.</span>
                        {/* START OF CONTACTS*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign:"center"}}>Contacts</h5>
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Email</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr key={`contact-${selectedTerminal?.value ?? ""}-${contactData?.[0]?.contactID ?? ""}`}>
                                            <td>
                                                <input
                                                    name="nameRow1"
                                                    style={{ ...styles.input, borderColor: formErrors.nameRow1 && "red" }}
                                                    defaultValue={contactData?.[0]?.contactName ?? ""}
                                                    className="form-control form-control-sm col-md-9"
                                                    type="text"
                                                    placeholder="Name"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    name="PhoneRow1"
                                                    defaultValue={contactData?.[0]?.phone ?? ""}
                                                    style={{ ...styles.input, borderColor: formErrors.phoneRow1 && "red" }}
                                                    className="form-control form-control-sm col-md-9"
                                                    type="text"
                                                    placeholder="Phone"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    name="emailRow1"
                                                    defaultValue={contactData?.[0]?.email ?? ""}
                                                    style={{ ...styles.input, borderColor: formErrors.emailRow1 && "red" }}
                                                    className="form-control form-control-sm col-md-9"
                                                    type="text"
                                                    placeholder="Email"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* START OF NOTES*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3">Notes</h5>
                                <div className="col-md-12">
                                    {ConsoleHelper(" notesDetails ", notesDetails)}
                                    <div
                                         style={{ ...styles.input, borderColor: formErrors.notesText && "red" }}
                                         className="form-group row">
                                        <textarea rows="4"  name="notesText"
                                                  defaultValue={ notesDetails?.noteText}
                                                  key={notesDetails?.noteText} cols="500"></textarea>
                                    </div>


                                </div>
                            </div>
                        </div>
                          {saveMessage && (
                              <div className="row">
                                  <div className="col-12">
                                      <div className={`alert alert-${saveMessage.variant} mb-3`} role="alert">
                                          {saveMessage.text}
                                      </div>
                                  </div>
                              </div>
                          )}
                          <div className="row" style={{marginLeft:"auto"}}>
                              <div className="col-md-3">
                                  <button
                                      type="submit"
                                      className="btn btn-1block btn-primary w-md"
                                      disabled={saveInProgress || terminalDetailLoading}
                                  >
                                      {saveInProgress
                                          ? "Saving…"
                                          : terminalDetailLoading
                                            ? "Loading…"
                                            : "Save"}
                                  </button>
                              </div>
                              {/*<div className="col-md-3">
                                  <button type="reset" className="btn btn-block btn-primary w-md">Reset
                                  </button>
                              </div>*/}
                              <div className="col-md-3">
                                  <button className="btn btn-block btn-primary w-md"
                                      type="button"
                                      onClick={() => editFormRef.current?.reset()}
                                      value="Reset"
                                  >Reset</button>
                              </div>
                          </div>
                      </form>
                    </div>

                </div>
            </div>

        </div>
            );

}

export default TerminalEditPage;